import type {
  RouteLocationNormalized,
  RouteLocationRaw,
} from 'vue-router';

import { validateAuth } from './auth.guard';
import { validateKyc } from './kyc.guard';
import { setExecutiveData } from './executive-data.guard';
import { validateWalletAndTerms } from './wallet-terms.guard';
import { validateFirebaseFeatureFlags } from './firebase-feature-flags.guard';
import { validateAccessRol } from './access-rol.guard';
import { validateNavigation } from './navigation.guard';
import { validateCardCountryAvailability } from '@/modules/card/router/card-availability.guard';
import { validateOffshoreLandingEligibility } from '@/modules/card/router/offshoreLanding.guard';
import { validatePaymentLinksAvailability } from '@/modules/paymentLinks/router/paymentLinks-availability.guard';
import { validateRfqInstitutionalAccess } from '@/modules/rfq/router/rfq-institutional.guard';
import { validateRfqMultiTransactionFeatureFlag } from '@/modules/multiTransactionV2/router/rfq-multi-transaction.guard';
import { validateComexAvailability } from '@/modules/comex/router/comex-availability.guard';

export type RouterGuard = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized
) =>
  | Promise<boolean | RouteLocationRaw | string | void>
  | boolean
  | RouteLocationRaw
  | string
  | void;

// Se ejecutan en el orden definido.
export const routerGuards: RouterGuard[] = [
  validateAuth,
  validateAccessRol,
  validateKyc,
  setExecutiveData,
  validateWalletAndTerms,
  validateFirebaseFeatureFlags,
  validateRfqMultiTransactionFeatureFlag,
  validateNavigation,
  validateCardCountryAvailability,
  validateOffshoreLandingEligibility,
  validatePaymentLinksAvailability,
  validateRfqInstitutionalAccess,
  validateComexAvailability,
];
export const executeGuards = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized
) => {
  if (routerGuards.length === 0) {
    return true;
  }

  // Ejecutar guardias en cadena
  for (const guard of routerGuards) {
    const result = await guard(to, from);
    // Si el guardia devuelve algo que no es true/undefined, interrumpir la cadena
    if (result !== true && result !== undefined) {
      return result;
    }
  }

  return true;
};
